/**
 * Account (`/account`, from the user menu): what belongs to the signed-in person rather than to the catalog. Their
 * MCP tokens and API keys moved to Integrations, which this page points to for whoever may use them.
 */

import { Link } from 'react-router-dom';

import { useSession } from '@/session/SessionContext';
import { PageHead } from '@/ui/PageHead';
import { StateCard } from '@/ui/StateCard';
import { UserRound, Waypoints } from 'lucide-react';

export function AccountPage() {
  const { user, can } = useSession();
  const connects = can('mcp.token.manage.own', 'api.key.manage.own');
  return (
    <>
      <PageHead title="Account" subtitle={user ? `${user.display_name} · ${user.email}` : ''} />
      {connects ? (
        <StateCard icon={<Waypoints aria-hidden="true" />} title="MCP tokens and API keys are on Integrations">
          <p>
            <Link to="/integrations?tab=mcp">Open Integrations</Link> to manage your MCP tokens, AI tool connections and API
            keys, and to read the API reference.
          </p>
        </StateCard>
      ) : (
        <StateCard icon={<UserRound aria-hidden="true" />} title="Nothing to manage here yet">
          <p>Settings for your account will appear here when they are available to you.</p>
        </StateCard>
      )}
    </>
  );
}
